// Story section component
import StoryPreview from './StoryPreview';
import StatusBar from '../Upload/StatusBar';

interface StorySectionProps {
  currentUser: {
    id: string;
    username: string;
    avatar_url?: string;
    is_page?: boolean;
    is_music_page?: boolean;
    verified?: boolean;
  };
  stories?: Array<{
    id: string;
    user: {
      id: string;
      username: string;
      avatar_url?: string;
      is_page?: boolean;
      verified?: boolean;
    };
    viewed?: boolean;
  }>;
  onStoryClick?: (storyId: string) => void;
  onAddStoryClick?: () => void;
  onPostSubmit?: (content: string, mediaType: string, privacy: string) => void;
}

export default function StorySection({
  currentUser,
  stories = [],
  onStoryClick,
  onAddStoryClick,
  onPostSubmit
}: StorySectionProps) {
  return (
    <div className="mb-2">
      {/* Story Preview Row */}
      <StoryPreview
        currentUser={currentUser}
        stories={stories}
        onStoryClick={onStoryClick}
        onAddStoryClick={onAddStoryClick}
      />

      {/* Upload Box with Privacy Selector */}
      <StatusBar
        user={currentUser}
        onPostSubmit={onPostSubmit}
      />
    </div>
  );
}
